import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.png";
import styles from "../../css/legal.module.css";

const TermsPage = () => {
  return (
    <Fragment>
      <Navbar hclass={"header-style-1"} Logo={Logo} btnClass={"theme-btn-s1"} />
      <PageTitle pageTitle={"Terms & Conditions"} pagesub={"Terms & Conditions"} />

      <section className={styles.section}>
        <div className={styles.container}>
          <p className={styles.updated}>Last updated: January 2026</p>

          <p className={styles.lead}>
            Welcome to Roslindale Food Collective. By accessing or using our
            website, you agree to these Terms &amp; Conditions. Please read them
            carefully.
          </p>

          <div className={styles.block}>
            <h2>About Us</h2>
            <p>
              Roslindale Food Collective is a 501(c)(3) nonprofit organization
              (EIN 93-4951322) dedicated to reducing food waste and supporting
              our community with fresh food and produce. This website is provided
              for informational purposes and to help our neighbors learn about,
              support, and participate in our mission.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Use of the Website</h2>
            <p>You agree to use this website only for lawful purposes. You may not:</p>
            <ul>
              <li>Use the site in a way that could damage, disable, or impair it;</li>
              <li>Attempt to gain unauthorized access to any part of the site;</li>
              <li>Use content from this site for commercial purposes without permission.</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h2>Donations</h2>
            <p>
              Donations are processed through third-party platforms (such as
              Venmo and other payment providers) and are subject to their terms.
              Roslindale Food Collective does not store payment information on
              this website. Donations to RFC are used to support our nonprofit
              mission. As a 501(c)(3) organization, contributions may be
              tax-deductible to the extent permitted by law.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Food Distribution</h2>
            <p>
              Food distribution details, times, and guidelines are shared for
              convenience and may change. Distribution is offered on a
              first-come, first-served basis and subject to availability. Please
              follow all posted guidelines at our distribution location.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Intellectual Property</h2>
            <p>
              All content on this website, including text, logos, and images, is
              the property of Roslindale Food Collective or used with permission,
              and may not be reproduced without consent.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Disclaimer</h2>
            <p>
              This website is provided "as is" without warranties of any kind.
              We strive to keep information accurate and up to date but cannot
              guarantee it is complete or error-free.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Contact Us</h2>
            <p>
              Questions about these Terms? Contact us at{" "}
              <a href="mailto:RosiFoodCollective@gmail.com">
                RosiFoodCollective@gmail.com
              </a>{" "}
              or 617-676-1717.
            </p>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default TermsPage;
